var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-1.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2712",
    "data-name": "Group 2712",
    transform: "translate(1.15 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    d: "M9.15-.85a10,10,0,0,1,10,10,10,10,0,0,1-10,10,10,10,0,0,1-10-10,10,10,0,0,1,10-10Zm0,18.433A8.433,8.433,0,1,0,.717,9.15,8.443,8.443,0,0,0,9.15,17.583Z",
    transform: "translate(0.85 0.85)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M15.619,14.09a.78.78,0,0,1-.35-.083l-3.687-1.843a.783.783,0,0,1-.433-.7V5.933a.783.783,0,0,1,1.567,0v5.046l3.254,1.627a.784.784,0,0,1-.351,1.484Z",
    transform: "translate(-1.933 -1.463)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f62cf59b2dbd06386b3ac4431a07902d.svg";
export { ForwardRef as ReactComponent };